<div class="home-container" *ngIf="!exibirFichaDaObra">
  <app-bloco-obras-responsabilidade></app-bloco-obras-responsabilidade>

  <div class="home-grid">
    <app-bloco-tarefas></app-bloco-tarefas>
    <app-bloco-buscas-salvas></app-bloco-buscas-salvas>
  </div>

  <div class="home-grid-second">
    <app-bloco-status-rede></app-bloco-status-rede>
    <app-bloco-solicitar-nova-obra></app-bloco-solicitar-nova-obra>
    <app-bloco-relatorios></app-bloco-relatorios>
  </div>

  <div class="home-grid-bottom">
    <app-bloco-novas-oportunidades
      (abrirFicha)="abrirFichaObra($event)"
    ></app-bloco-novas-oportunidades>
  </div>
</div>

